import React, { useEffect, useState, useReducer } from 'react';
import { Link } from "react-router-dom";
import useGoogleCaptcha from '../../components/useReCaptcha.js';

import WebsiteScanForm from '../../components/scanWebsite.js'
import FAQ from '../../components/faqComponent.js'


import {TechnologyScanPageResult} from '../../../../server/routes/technology-scan.js'
import {RtFAQItem} from '../../../../server/routes/route-types.js'

export default function WebsiteScan({ server, pageData }: { server: string; pageData: unknown }) {

	let [data, setData] = useState(pageData as TechnologyScanPageResult);
    const google = useGoogleCaptcha();

    let faqs = data.faqs.map((f) => {
        const processedFAQ: RtFAQItem = {
            question: f.question,
            answer: f.answer, 
            questionhtml: f.questionhtml === undefined ? f.question : f.questionhtml,
            answerhtml: f.answerhtml === undefined ? f.answer : f.answerhtml,
            skipFromJson: !!f.skipFromJson            
        }

        return processedFAQ;
    })

	return (
        <>
             <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h3 className="text-left mb-3">Uncover Website Technologies with a Quick Scan</h3>
                            <p>
                            Our technology profiling scan identifies the software and tools powering a website—such as content management systems, JavaScript libraries, web servers, and more. 
                            The scan assists in stack fingerprinting, dependency mapping, and can aid in security assessments and competitive intelligence.
                            </p>
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <WebsiteScanForm    
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey}
                                google={google}
                                domain={data.Domain}
                                readonly={false}
                                /> 
                            <FAQ faqs={faqs} expanded='1'/>
                        </div>
                    </div>       
                </div> 
            </section>
   
        </>
    )
}

